import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { RootLayout } from "./components/layout/root-layout";
import { DataProvider } from "./context/data-provider";
import Dashboard from "./pages/dashboard";
import Plano from "./pages/plano";
import Agenda from "./pages/agenda";
import Medicos from "./pages/medicos";
import Cobertura from "./pages/cobertura";
import Analise from "./pages/analise";
import Apoios from "./pages/apoios";
import TodoPage from "./pages/todo";
import Periodo from "./pages/periodo";
import Configuracoes from "./pages/configuracoes";

import "./index.css";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <DataProvider>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="plano" element={<Plano />} />
          <Route path="agenda" element={<Agenda />} />
          <Route path="medicos" element={<Medicos />} />
          <Route path="cobertura" element={<Cobertura />} />
          <Route path="analise" element={<Analise />} />
          <Route path="apoios" element={<Apoios />} />
          <Route path="todo" element={<TodoPage />} />
          <Route path="periodo" element={<Periodo />} />
          <Route path="configuracoes" element={<Configuracoes />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      </DataProvider>
    </BrowserRouter>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}

// Register service worker for PWA
if ("serviceWorker" in navigator && !import.meta.hot) {
  navigator.serviceWorker.register("/sw.js").then((reg) => {
    if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
    reg.addEventListener("updatefound", () => {
      const nw = reg.installing;
      if (!nw) return;
      nw.addEventListener("statechange", () => {
        if (nw.state === "installed" && navigator.serviceWorker.controller) {
          nw.postMessage("SKIP_WAITING");
        }
      });
    });
  });
  navigator.serviceWorker.addEventListener("message", (e) => {
    if (e.data?.type === "SW_UPDATED") window.location.reload();
  });
}
